import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Cookie } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already given consent
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const logConsent = async (consentType) => {
    try {
      await axios.post(`${API_URL}/api/cookie-consent/log`, {
        consent_type: consentType,
        page_url: window.location.href,
        session_id: sessionStorage.getItem('sessionId') || Math.random().toString(36).substring(7)
      });
    } catch (error) {
      console.error('Failed to log consent:', error);
    }
  };

  const handleAccept = async () => {
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    await logConsent('accepted');
    setShowBanner(false);
  };

  const handleDecline = async () => {
    localStorage.setItem('cookieConsent', 'declined');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    await logConsent('declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 p-4 shadow-lg border-t"
      style={{
        backgroundColor: '#1A1F2E',
        borderColor: '#2A3142',
      }}
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-start gap-3 flex-1">
          <Cookie className="w-6 h-6 flex-shrink-0 mt-1" style={{ color: '#7CD4FD' }} />
          <div>
            <p className="text-sm" style={{ color: '#E6EDF3' }}>
              <strong>Wir verwenden Cookies</strong>
            </p>
            <p className="text-xs mt-1" style={{ color: '#94A3B8' }}>
              Diese Website verwendet Cookies, um Ihnen die bestmögliche Erfahrung zu bieten. 
              Weitere Informationen finden Sie in unserer{' '}
              <a 
                href="/datenschutz" 
                className="underline hover:no-underline"
                style={{ color: '#7CD4FD' }}
              >
                Datenschutzerklärung
              </a>.
            </p>
          </div>
        </div>
        
        <div className="flex gap-3 flex-shrink-0">
          <Button
            onClick={handleDecline}
            variant="outline"
            size="sm"
            style={{
              borderColor: '#3A4152',
              color: '#94A3B8',
            }}
          >
            Ablehnen
          </Button>
          <Button
            onClick={handleAccept}
            size="sm"
            style={{
              backgroundColor: '#1EA0E6',
              color: '#ffffff',
            }}
          >
            Akzeptieren
          </Button>
        </div>
      </div>
    </div>
  );
};
